/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from 'react';
import { render } from 'react-dom';
import Styles from './styles';
import { Form, Field } from 'react-final-form';

import { Grid, InputAdornment, FormControl, InputLabel, 
		OutlinedInput, IconButton, FormHelperText, Button, 
		Collapse
	} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { CompassCalibrationOutlined, PhotoSizeSelectActual, Visibility, VisibilityOff } from '@material-ui/icons';
import { makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import { TextField, Switches, Checkboxes, showErrorOnBlur, makeValidate } from 'mui-rff';

import * as Yup from 'yup';

import { GoogleReCaptcha, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import ZXOUtils from './components/zxo_utils.js';

import intl from 'react-intl-universal';

import en_GB from './locales/en_GB.json';
import ru_RU from './locales/ru_RU.json';

let clang = ('current_lang' in document) ? document.current_lang : 'en';
let clocale = '';
switch (clang) {
	case 'ru':
		clocale = 'ru_RU';
		break;
	default:
		clocale = 'en_GB';
}

intl.init({
	currentLocale: clocale,
	locales: {
		'en_GB': en_GB,
		'ru_RU': ru_RU,	
	},
});

const darkTheme = createMuiTheme({
	palette: {
		type: 'dark',
	},
});

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiFormControl-root': {
			margin: theme.spacing(1),
			width: '100%',
			'& input, & textarea, & select': {
				border: 0,
				lineHeight: 'inherit',
				font: 'inherit',
				height: 'auto',
				padding: '18.5px 14px',
			}
		},
		'& .MuiAlert-standardError': {
			backgroundColor: '#610a05',
		},
		'& .MuiAlert-standardSuccess': {
			backgroundColor: '#246724',
		},
		'& .MuiAlert-root': {
			fontSize: '1rem',
		},
		'& .MuiFormHelperText-root': {
			fontSize: '0.9rem',
		},
		'& .bottom-alert': {
			marginTop: '15px',
		}
	},
}));

// We define our schema based on the same keys as our form:
const schema = Yup.object().shape({
	first_name: Yup.string().required(),
	email: Yup.string().email().required(),
	//password: Yup.string().required(),
	notify: Yup.boolean().required().oneOf([true], 'register.validate.agree'),
	toc: Yup.boolean().required().oneOf([true], 'register.validate.agree'),
});

// Run the makeValidate function...
const validate = makeValidate(schema, (error) => {
	//console.log(JSON.stringify(error));

	let path = error.path || '';

	let key = '';
	switch (error.type || '') {
		case 'required':
			key = 'register.validate.required';
			break;
		case 'email':
			key = 'register.validate.email';
			break;
		case 'oneOf':
			key = error.message || 'register.validate.unknown';
			break;
		default:
			//console.log(JSON.stringify(error));
			key = error.type || '';
	}

	//if (error.path == 'password') {
	//	console.log(JSON.stringify(error));
	//}

	if (key.length > 0) {
		return intl.get(key, {field: path});
	} else {
		return intl.get('register.validate.unknown');
	}
});

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export default function App() 
{
	const classes = useStyles();

	const [showPassword, setShowPassword] = useState(false);
	const [password, setPassword] = useState('');
	const [passwordErrorText, setPasswordErrorText] = useState('');
	const [isPasswordError, setIsPasswordError] = useState(false);
	const [isBeforePasswordEdit, setIsBeforePasswordEdit] = useState(true);
	const [global_error, setGlobalError] = useState(false);
	const [global_success, setGlobalSuccess] = useState(false);

	const { executeRecaptcha } = useGoogleReCaptcha();

	const onSubmit = async values => {

		setGlobalError(false);
		setGlobalSuccess(false);

		await sleep(1);

		if (isPasswordError) {
			return;
		}

		let password_hash = await executeRecaptcha("REGISTRATION_page");

		let vs = {password, password_hash, ...values};

		//window.alert(JSON.stringify(vs, 0, 2));

		let data = await ZXOUtils.Call_API({
			'action': 'gr3check',
			'gr3key': JSON.stringify(vs),
		});

		if ('code' in data) {
			switch (data['code']) {
				case 0:
					// All OK
					setGlobalSuccess(intl.get('register.submit.success'));

					await sleep(500);

					// Redirect
					document.location.href = '/registration-finish/?code=' + data['url_hash'];
					break;
				case -4:
					setGlobalError(intl.getHTML('register.submit.email_exists', {url: '/my-account/'}));
					break;
				case -7:
					setGlobalError(intl.get('register.submit.blacklist'));
					break;
				default:
					setGlobalError('Code: ' + data['code'] + ' ' + intl.get('register.submit.unknown'));
			}
		} else {
			setGlobalError('100: ' + intl.get('register.submit.unknown'));
		}
	};

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};
	
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	function ValidatePassword(password)
	{
		// Check password
		let err = '';
		let is_length = false;
		let is_small = false;
		let is_capital = false;
		let is_digit = false;
		let is_space = true;
		let is_fine = false;
		if (password.length > 0) {
			if (password.length >= 8) {
				is_length = true;
			}
			if (password.match(/[a-z]{1}/)) {
				is_small = true;
			}
			if (password.match(/[A-Z]{1}/)) {
				is_capital = true;
			}
			if (password.match(/[0-9]{1}/)) {
				is_digit = true;
			}
			if (password.match(/[\x20]{1}/)) {
				is_space = false;
			}
			err = [];
			if (is_length) {
				err.push(<span style={{color: '#aaa'}} key="1">{intl.get('register.validate.password1')}</span>);
			} else {
				err.push(<span className="error" key="1_">{intl.get('register.validate.password1')}</span>);				
			}
			if (is_small) {
				err.push(<span style={{color: '#aaa'}} key="2">{intl.get('register.validate.password2')}</span>);
			} else {
				err.push(<span className="error" key="2_">{intl.get('register.validate.password2')}</span>);				
			}
			if (is_capital) {
				err.push(<span style={{color: '#aaa'}} key="3">{intl.get('register.validate.password3')}</span>);
			} else {
				err.push(<span className="error" key="3_">{intl.get('register.validate.password3')}</span>);				
			}
			if (is_digit) {
				err.push(<span style={{color: '#aaa'}} key="4">{intl.get('register.validate.password4')}</span>);
			} else {
				err.push(<span className="error" key="4_">{intl.get('register.validate.password4')}</span>);				
			}
			if (is_space) {
				err.push(<span style={{color: '#aaa'}} key="5">{intl.get('register.validate.password5')}</span>);
			} else {
				err.push(<span className="error" key="5_">{intl.get('register.validate.password5')}</span>);				
			}

			is_fine = is_length && is_small && is_capital && is_digit && is_space;
		} else {
			err = intl.get('register.validate.required');
		}

		if (is_fine) {
			err = <span style={{color: '#0a0'}}>{intl.get('register.validate.password_fine')}</span>;
		}

		setPasswordErrorText(err);
		setIsPasswordError(!is_fine);
		setIsBeforePasswordEdit(false);
	}

	const onPasswordBlur = (event) => {
		//let password = event.target.value.trim();
		onPasswordChange(event);
	};

	const onPasswordChange = (event) => {
		let password = event.target.value;
		setPassword(password);

		ValidatePassword(password);
	};

	function handleBtnSubmit(cb, event)
	{
		ValidatePassword(password);
		cb(event);
	}

	return (
	<ThemeProvider theme={darkTheme}>
	<div className={classes.root}>
    <h1>{intl.get('register.form.title')}</h1>
	<Form
      onSubmit={onSubmit}
      initialValues={{ }}
	  validate={validate}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit}>
			<Grid container>
				<Grid item>
					<TextField label={[intl.get('register.fieldname.first_name'), " *"]} name="first_name" variant="outlined" showError={showErrorOnBlur}/>
					<TextField label={[intl.get('register.fieldname.last_name'), ""]} name="last_name" variant="outlined" />
					<TextField label={[intl.get('register.fieldname.email'), " *"]} name="email" variant="outlined" showError={showErrorOnBlur}/>
					<FormControl variant="outlined" error={isPasswordError}>
          				<InputLabel htmlFor="standard-adornment-password">{[intl.get('register.fieldname.password'), " *"]}</InputLabel>
          				<OutlinedInput
            				id="standard-adornment-password"
            				type={showPassword ? 'text' : 'password'}
							label={[intl.get('register.fieldname.password'), " *"]}
							name="password"
							value={password}
            				endAdornment={
              					<InputAdornment position="end">
                					<IconButton
                 	 					aria-label="toggle password visibility"
                  						onClick={handleClickShowPassword}
                  						onMouseDown={handleMouseDownPassword}
										edge="end"
                					>
              	    					{showPassword ? <Visibility /> : <VisibilityOff />}
                					</IconButton>
              					</InputAdornment>
            				}
							onBlur={onPasswordBlur}
							onChange={onPasswordChange}
          				/>
						<FormHelperText id="standard-adornment-password-text">{!isBeforePasswordEdit ? passwordErrorText : intl.get('register.helper.password')}</FormHelperText>
        			</FormControl>
					<div>
					<Checkboxes
						label={false}
    					name="notify"
    					data={{label: intl.get('register.fieldname.notify'), value: true}}
					/>
					<Checkboxes
						label={false}
    					name="toc"
    					data={{label: [intl.get('register.fieldname.toc'), <a key={777} href="/terms-and-conditions/" target="_blank">{intl.get('register.fieldname.toc2')}</a>], value: true}}
					/>
					</div>
					<div style={{justifyContent: 'center', display: 'flex'}}>
					<Button 
						variant="contained" 
						color="primary" 
						disabled={submitting} 
						onClick={(event) => handleBtnSubmit(handleSubmit, event)}>
							{intl.get('register.fieldname.submit')}
					</Button>

					</div>
					<Collapse in={global_error !== false}>
						<Alert severity="error" className="bottom-alert">{global_error}</Alert>
					</Collapse>
					<Collapse in={global_success !== false}>
						<Alert severity="success" className="bottom-alert">{global_success}</Alert>
					</Collapse>
				</Grid>
			</Grid>
        </form>
      )}
    />
  </div>
  </ThemeProvider>
  );
}
